import { 
    useContext,
    useEffect,
    useRef,
    useState,
    useCallback,
    forwardRef
} from 'react';

import { 
    motion, 
    usePresence,
    AnimatePresence,
    useMotionValue,
    useTransform
} from 'framer-motion';


import { 
    ActionContext,
    SettingsContext
} from '../../../src/view.jsx';

import { 
    getPreset,
    dragPreset 
} from './presets.jsx';


export default function WpBlockCwcSlide( {
    children: innerBlocks,
    media, 
    dimRatio, 
    focalPoint,
    mediaFit, 
    overlayColor,
    customOverlayColor,
    overlayGradient,
    customOverlayGradient,
    //style,
    ...otherProps
} ) {
    const [width, setWidth] = useState( 300 )
    const ref = useCallback( node => {
        if ( node ) {
            const { width } = node.getBoundingClientRect()

            setWidth( width )
        }
    } )
    const videoRef = useRef()

    const [mediaBlock, contentBlock] = innerBlocks
    const {
        children: mediaInnerBlocks,
        ...mediaInnerBlockProps
    } = mediaBlock.props

    const {
        children: contentInnerBlocks,
        ...contentInnerBlockProps
    } = contentBlock.props

    const { 
        type,
        effect, 
        rate,
        hasControls,
        direction,
        autoplay,
        hasMobile
    } = useContext( SettingsContext )

    const { 
        processing,
        setProcessing, 
        currentIndex: [
            prev,
            current,
            next
        ],
        switchSlide,
        setPlay
    } = useContext( ActionContext )

    //const x = useMotionValue( 0 )
    //const opacity = useTransform( x, [ -width, 0, width ], [ 0, 1, 0 ] )


    const swipeConfidenceThreshold = 10000
    const swipePower = ( offset, velocity ) => {
        return Math.abs( offset ) * velocity;
    }

    //console.log(width)

    /*if ( !media?.id ) {
        contentInnerNode = mediaNode // if not media
    }
    
    const [ overlayNode ] = media?.id ? Array.from( mediaNode.children ) : []


    const toggleVisible = () => {
        togglePlayVideo( document.visibilityState === 'visible' )
    }


    const togglePlayVideo = action => {
        action && isVisible ? videoRef.current.play() : videoRef.current.pause()
    }


    /**
     * Play video arter change slide
     */
    /*useEffect( () => {
        if ( videoRef.current ) {
            togglePlayVideo( !processing )
        }
    }, [processing] )*/

    //console.log(media, contentBlock, isPresent)


    return (
        <AnimatePresence 
            initial={ false } 
            custom={ direction }
        >
            <motion.div
                {...otherProps}
                ref={ ref }
                /*style={ {
                    ...style,
                    //x,
                    //opacity
                } }*/
                key={ current }
                custom={ direction }
                variants={ type != 'background' && hasMobile ? dragPreset : getPreset( effect ) }
                initial="enter"
                animate="center"
                exit="exit"
                drag={ type != 'background' && hasMobile && !processing ? 'x' : null }
                dragElastic={ 1 }
                dragConstraints={ { 
                    left: 0, 
                    right: 0 
                } }
                transition={ type != 'background' && hasMobile ? {
                    x: { 
                        type: 'spring', 
                        stiffness: 300, 
                        damping: 30 
                    },
                    opacity: { 
                        duration: 0.2 
                    }
                } : {
                    duration: rate / 1000
                } }
                onAnimationComplete={ definition => {
                    if ( definition == 'center' ) {
                        setProcessing( false )
                    }
                } }
                onDragStart={ ( event ) => {
                    if ( autoplay ) {
                        setPlay( false )
                    }
                } }
                onDragEnd={ ( event, { offset, velocity } ) => {
                    const swipe = swipePower( offset.x, velocity.x )
        
                    if ( swipe < -swipeConfidenceThreshold ) {
                        switchSlide( next, 'right' )
                    } else if ( swipe > swipeConfidenceThreshold ) {
                        switchSlide( prev, 'left' )
                    }

                    if ( autoplay ) {
                        setPlay( true )
                    }
                } }
            >
                { !!media?.url && 
                    <>
                        { hasMobile ? 
                            <figure {...mediaInnerBlockProps}>
                                { mediaInnerBlocks }
                            </figure>
                        :
                            <motion.figure 
                                {...mediaInnerBlockProps}
                                key={ `${current}__media` }
                                custom={ direction }
                                variants={ getPreset( effect, 'media' ) }
                                initial="enter"
                                animate="center"
                                exit="exit"
                                transition={ {
                                    duration: rate / 1000
                                } }
                            >
                                { mediaInnerBlocks }
                            </motion.figure>
                        }
                    </>
                }

                { hasMobile ? 
                    <div {...contentInnerBlockProps}>
                        { contentInnerBlocks }
                    </div>
                :
                    <motion.div
                        {...contentInnerBlockProps}
                        key={ `${current}__content` }
                        variants={ getPreset( effect, 'content' ) }
                        initial="enter"
                        animate="center"
                        exit="exit"
                        transition={ {
                            duration: rate / 1000
                        } }
                    >
                        { contentInnerBlocks }
                    </motion.div>
                }
            </motion.div>
        </AnimatePresence>
    )
}


//export default motion( WpBlockCwcSlide )